/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_TitleInputs */

const en_ui_te_title = /** @type {(inputs: Ui_Te_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training effect`)
};

const de_ui_te_title = /** @type {(inputs: Ui_Te_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingseffekt`)
};

/**
* | output |
* | --- |
* | "Training effect" |
*
* @param {Ui_Te_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_title = /** @type {((inputs?: Ui_Te_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_title(inputs)
	return de_ui_te_title(inputs)
});